<template>
	<div class="card-header-img-box">
		<img :src="store.img_mid" class="cm-store-img img-fluid" alt="" />
	</div>
	<div class="card-body">
		<h5>{{ store.title }}</h5>
		<address>
			{{ store.addr_firma }}<br />
			{{ store.addr_street }}<br />
			{{ store.addr_plz }} {{ store.addr_city }}<br />
		</address>
		<div class="row g-2">
			<div class="col-12 col-md-8">
				<a :href="'tel:' + store.phone_vk_link" class="btn btn-dark btn-block"
					><i class="mdi mdi-phone"></i> {{ store.phone_vk }}</a
				>
			</div>
			<div class="col-12 col-md-4">
				<a
					:href="store.google_map_link"
					target="_blank"
					class="btn btn-light btn-block"
					><i class="mdi mdi-routes"></i> Route</a
				>
			</div>
		</div>
	</div>
	<div class="card-body border-top">
		<h6 class="mb-3">Öffnungszeiten Verkauf</h6>
		<div class="row no-gutters">
			<div class="col-5">
				<span class="label">Montag - Freitag:</span>
			</div>
			<div class="col-7 font-18 font-w-500">{{ openTimes.open_time_wo }}</div>
			<div class="col-5">
				<span class="label">Samstag:</span>
			</div>
			<div class="col-7 font-18 font-w-500">{{ openTimes.open_time_sa }}</div>
		</div>
	</div>
	<div class="card-body border-top">
		<h6 class="mb-3">Unser Verkaufsteam</h6>
		<div class="d-block contact-users mb-3">
			<div
				v-for="user in store.users"
				:key="user.id"
				class="contact-user w-100 d-flex align-items-center"
			>
				<img
					:src="user.user_img"
					:alt="user.firstname + ' ' + user.lastname"
					class="rounded-circle"
				/>
				<div class="contact-user-body">
					<p class="font-18 font-w-500 mb-0">
						{{ user.firstname }} {{ user.lastname }}
					</p>
					<p class="text-muted mb-0">{{ user.position }}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DetailsContactStore',
	props: {
		store: {
			type: Object,
			required: true,
		},
	},
	computed: {
		openTimes() {
			return this.store.oeffnungszeiten.oeffnungszeiten0
		},
	},
	created() {},
}
</script>

<style lang="scss">
.contact-users {
	.contact-user {
		margin-bottom: $px10;

		img {
			height: 60px;
			width: 60px;
			margin-right: $px10;
		}

		.contact-user-body {
		}
	}
}
</style>
